import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ROUTE_NAMES } from '@app/core/navigation/navigation.constants';
import { ProfileState } from '@app/layout/common/profile/state/profile.state';
import { TimesheetDetailsComponent } from '@timesheet/details/details.component';
import { TimesheetActions } from '@timesheet/state/timesheet.actions';
import { TimesheetState } from '@timesheet/state/timesheet.state';
import { catchError, of, take, throwError } from 'rxjs';

export const timesheetsResolver = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const timesheetActions = inject(TimesheetActions);
  const router = inject(Router);

  timesheetActions.actions.getTimesheets({ queryParams: route.queryParams });

  return of({}).pipe(
    catchError((error) => {
      const parentUrl = state.url.split('/').slice(0, -1).join('/');

      router.navigateByUrl(parentUrl).then();

      return throwError(() => error);
    })
  );
};

export const timesheetResolver = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const timesheetActions = inject(TimesheetActions);
  const timesheetState = inject(TimesheetState);
  const profileState = inject(ProfileState);
  const router = inject(Router);

  if (route.paramMap.get('id') === 'new') {
    const timesheet = {
      id: '',
      master_name: '',
      voyage_number: '',
      date_timesheet: null,
      type_id: null,
      port_id: null,
      location_id: null,
      cargo_name: '',
      quantity_document: '',
      quantity_ship: '',
      remarks: '',
      owner_company_id: profileState.ownerCompanyId(),
      vessel_id: profileState.profileId()
    };

    timesheetState.set({ timesheet });

    return true;
  }

  timesheetActions.actions.getTimesheetById({ id: route.paramMap.get('id') });

  return timesheetActions.actions.getTimesheetByIdSuccess$.pipe(
    take(1),
    catchError((error) => {
      const parentUrl = state.url.split('/').slice(0, -1).join('/');

      router.navigateByUrl(parentUrl).then();

      return throwError(() => error);
    })
  );
};

export const canDeactivateTimesheetDetails = (
  component: TimesheetDetailsComponent,
  _currentRoute: ActivatedRouteSnapshot,
  _currentState: RouterStateSnapshot,
  nextState: RouterStateSnapshot
) => {
  let nextRoute: ActivatedRouteSnapshot = nextState.root;
  while (nextRoute.firstChild) {
    nextRoute = nextRoute.firstChild;
  }

  if (!nextState.url.includes(`/${ROUTE_NAMES.TIMESHEET}`)) {
    return true;
  }

  if (nextRoute.paramMap.get('id')) {
    return true;
  }

  return component?.closeDrawer && component.closeDrawer().then(() => true);
};
